/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_create_password_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a password (min 6 characters)`)
};

const zh_hans1_settings_create_password_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建密码（至少 6 个字符）`)
};

const zh_hant1_settings_create_password_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立密碼（至少 6 個字元）`)
};

const fr_settings_create_password_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un mot de passe (min. 6 caractères)`)
};

const de_settings_create_password_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort erstellen (mind. 6 Zeichen)`)
};

const ja_settings_create_password_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードを作成（6 文字以上）`)
};

const ko_settings_create_password_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호를 생성하세요(최소 6자)`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_create_password_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_create_password_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_create_password_placeholder", locale)
	if (locale === "en") return en_settings_create_password_placeholder(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_create_password_placeholder(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_create_password_placeholder(inputs)
	if (locale === "fr") return fr_settings_create_password_placeholder(inputs)
	if (locale === "de") return de_settings_create_password_placeholder(inputs)
	if (locale === "ja") return ja_settings_create_password_placeholder(inputs)
	return ko_settings_create_password_placeholder(inputs)
};